//Basic Form
export const BASIC_FORM = [
  {
    text: "Use the ",
    code: ".form-label ",
  },
  {
    text: "and ",
    code: ".form-control ",
  },
  {
    text: "through create basic form.",
  },
];

//Form Floating
export const FLOATING_FORM = [
  {
    text: "Use the ",
    code: ".form-floating",
  },
  {
    text: " through create floating form.",
  },
];

//Select Sizing
export const SIZING_FORM = [
  {
    code: ".form-select",
  },
  {
    text: " to trigger the custom styles. You may also choose from small and large custom selects to match our similarly sized text inputs. class:- ",
    code: "[form-select-lg/form-select-sm].",
  },
];

//Select Sizing
export const SELECT_FORM_LIST = ["What's Your Hobbies", "Kho-kho", "Reading Books", "Creativity"];

//Form Control Sizing
export const FORM_CONTROL_SIZING = [
  {
    text: "Set heights using classes like ",
    code: ".form-control-lg",
  },
  {
    text: " and ",
    code: ".form-control-sm",
  },
];

//File Inputs
export const FILE_INPUT = [
  {
    text: "For default file/multiple file/disabled file/small file/large file input for use ",
    code: "<input>",
  },
  {
    text: " with ",
    code: "(type='file').",
  },
];

export const FILE_INPUT_LIST = [
  {
    label: "Default file input example",
  },
  {
    label: "Multiple files input example",
    multiple: true,
  },
  {
    label: "Disabled file input example",
    disabled: true,
  },
  {
    label: "Small file input example",
    bsSize: "sm",
  },
  {
    label: "Large file input example",
    bsSize: "lg",
  },
];

//Flat Input Styles
export const FLAT_INPUT_STYLES = [
  {
    text: "Use the ",
    code: ".btn-square ",
  },
  {
    text: "through defined 0px border-radius.",
  },
];

export const FLAT_INPUT_STYLES_LIST = ["I", "II", "III", "IV", "V"];

export const FLAT_STYLES_LIST = ["Landscape", "Portrait", "Oil Painting", "Abstract art", "Acrylic"];

//Basic Html Input Control
export const BASIC_HTML_INPUT_CONTROL = [
  {
    text: "Give textual form controls like ",
    code: "<input>",
  },
  {
    text: " s and ",
    code: "<textarea>",
  },
  {
    text: "s an upgrade with custom styles, sizing, focus states, and more.",
  },
];

export const DATA_LISTS = ["San Francisco", "New York", "Seattle", "Los Angeles", "Chicago", "India"];

//Basic Floating Input Control
export const FLOATING_INPUT = [
  {
    text: "Give textual form controls like ",
    code: "<input>",
  },
  {
    text: "s and ",
    code: "<textarea>",
  },
  {
    text: "s an upgrade with custom styles, sizing, focus states, and more.",
  },
];

export const FLOATING_SELECT_TYPE = ["Open this select menu", "I", "II", "II"];

export const FLOATING_SELECT_TYPE_LIST = [
  {
    text: "Open this select menu",
  },
  {
    text: "One",
  },
  {
    text: "Two",
  },
  {
    text: "Three",
  },
];

//Edges Input Styles
export const EDGES_INPUT_STYLES = [
  {
    text: "Use the ",
    code: ".btn-pill ",
  },
  {
    text: "through defined 0px border-radius.",
  },
];

export const EDGE_LIST = ["Tivo", "Cuba", "Roxo", "Oslo", "Voxo", "Sheltos", "Petkart", "Zeta"];

//Raise input style
export const RAISED_INPUT_STYLES = [
  {
    text: "Use the ",
    code: "input-air-* ",
  },
  {
    text: "through defined bottom box-shadow.",
  },
];

export const RAISED_LIST = ["Tivo", "Roxo", "Wingo", "Cuba", "Koho"];

export const RAISED_COLOR_LIST = ["Red", "Yellow", "Orange", "White", "Black", "Gray", "Brown", "Purple", "White"];
